import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { exceptionMessage1cx0ho62128p8 as exceptionMessage } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/ElementContext.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { printStackTrace18lnx7a39cni as printStackTrace } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Build_instance1p6x8ddp69wvz as Build_instance } from '../../../../../kiteui-library/com/lightningkite/kiteui/Build.js.mjs';
import { get_selectedApi2lg32khtf3h6e as get_selectedApi } from '../sdk/apiOptions.mjs';
import { await1xlt6i5aa076q as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { AppReleasenhe0u1o4ickq as AppRelease } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/models.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import { get_platform114v8tgyas4i as get_platform } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { toAppPlatform36bnn01mmf21b as toAppPlatform } from '../extensions/Platform.ext.mjs';
import { eq353yrgcpovoi1 as eq } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { asSequence2phdjljfh9jhx as asSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { filter184huxd00uyfg as filter } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { ExceptionHandler6hcmz9gcndpu as ExceptionHandler } from '../../../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../strings.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Align_Center_getInstance366ihr7rj12mu as Align_Center_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints19w9rda6g3rqz as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { dialog3sxbjr735jrum as dialog } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var appUpdateChecked;
function checkAppVersion(_this__u8e3s4) {
  if (get_current(Companion_instance).equals(Platform_Web_getInstance()) || appUpdateChecked)
    return Unit_instance;
  appUpdateChecked = true;
  var tmp = get_AppScope();
  launch(tmp, VOID, VOID, checkAppVersion$slambda(_this__u8e3s4));
}
function checkAppVersion$slambda$lambda($this$ExceptionHandler, e, meta) {
  var message = exceptionMessage($this$ExceptionHandler, e, meta);
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  var tmp1_elvis_lhs = message == null ? null : message.title_1;
  // Inline function 'kotlin.text.appendLine' call
  var value = 'Suppressing error: ' + toString(tmp1_elvis_lhs == null ? e : tmp1_elvis_lhs);
  // Inline function 'kotlin.text.appendLine' call
  this_0.append_22ad7x_k$(value).append_58al37_k$(_Char___init__impl__6a9atx(10));
  if (message == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.text.appendLine' call
    var value_0 = message.body_1;
    // Inline function 'kotlin.text.appendLine' call
    this_0.append_22ad7x_k$(value_0).append_58al37_k$(_Char___init__impl__6a9atx(10));
  }
  var tmp$ret$0 = this_0.toString();
  println(tmp$ret$0);
  printStackTrace(e);
  return checkAppVersion$slambda$lambda$lambda;
}
function checkAppVersion$slambda$lambda$lambda() {
  return Unit_instance;
}
function checkAppVersion$slambda$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function checkAppVersion$slambda($this_checkAppVersion) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    var currentBuild = Build_instance.get_version_72w4j3_k$();
    var tmp;
    try {
      var tmp_0 = (yield* await_0(get_selectedApi(), $completion)).get_api_18j9e7_k$().appRelease_1;
      // Inline function 'com.lightningkite.services.database.condition' call
      // Inline function 'com.lightningkite.services.database.path' call
      // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
      var tmp_1 = serializerOrContextual(createKType(getKClass(AppRelease()), arrayOf([]), false));
      var tmp$ret$2 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
      // Inline function 'kotlin.let' call
      var it = new (DataClassPathSelf())(tmp$ret$2);
      var tmp$ret$0 = eq(get_platform(it), toAppPlatform(get_current(Companion_instance)));
      tmp = yield* tmp_0.query_o986pg_k$(new (Query())(tmp$ret$0), $completion);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Exception()) {
        var _unused_var__etf5q3 = $p;
        return Unit_instance;
      } else {
        throw $p;
      }
    }
    var releases = tmp;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$6;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = releases.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if (element.version_1 === currentBuild) {
          tmp$ret$6 = element;
          break $l$block;
        }
      }
      tmp$ret$6 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$6;
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    var currentRelease = tmp_3;
    var tmp$ret$8;
    $l$block_1: {
      // Inline function 'kotlin.collections.maxByOrNull' call
      var iterator = releases.iterator_jk1svi_k$();
      if (!iterator.hasNext_bitz1p_k$()) {
        tmp$ret$8 = null;
        break $l$block_1;
      }
      var maxElem = iterator.next_20eer_k$();
      if (!iterator.hasNext_bitz1p_k$()) {
        tmp$ret$8 = maxElem;
        break $l$block_1;
      }
      var maxValue = maxElem.releaseDate_1;
      do {
        var e = iterator.next_20eer_k$();
        var v = e.releaseDate_1;
        if (compareTo(maxValue, v) < 0) {
          maxElem = e;
          maxValue = v;
        }
      }
       while (iterator.hasNext_bitz1p_k$());
      tmp$ret$8 = maxElem;
    }
    var tmp1_elvis_lhs = tmp$ret$8;
    var tmp_4;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_4 = tmp1_elvis_lhs;
    }
    var latestRelease = tmp_4;
    var tmp_5;
    if (!equals(latestRelease._id_1, currentRelease._id_1)) {
      var tmp_6 = asSequence(releases);
      var tmp0 = filter(tmp_6, (it) => it.releaseDate_1.compareTo_e7gwgq_k$(currentRelease.releaseDate_1) > 0);
      var tmp$ret$11;
      $l$block_2: {
        // Inline function 'kotlin.sequences.any' call
        var _iterator__ex2g4s_0 = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          if (element_0.requiredUpdate_1) {
            tmp$ret$11 = true;
            break $l$block_2;
          }
        }
        tmp$ret$11 = false;
      }
      var updateRequired = tmp$ret$11;
      if (updateRequired) {
        var tmp_7 = $this_checkAppVersion.get_context_h02k06_k$().exceptionHandlers_1;
        tmp_7.plusAssign_4ugdj3_k$(ExceptionHandler(5.0, checkAppVersion$slambda$lambda));
      }
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_0 = get_strings(AppState_getInstance());
      var strings = yield* await_0(this_0, $completion);
      var tmp_8 = $this_checkAppVersion.get_context_h02k06_k$();
      var tmp_9 = !updateRequired;
      dialog(tmp_8, tmp_9, ($this$dialog, close) => {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())($this$dialog.get_context_h02k06_k$());
        ensureOutermostElement(element);
        $this$dialog.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (TextView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        element_0.set_align_ypalx0_k$(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = strings.get_checkVersionTitle_5bcopt_k$();
        var tmp = element_0.native_1;
        var tmp_0;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_0 = '\xA0';
        } else {
          tmp_0 = value;
        }
        tmp.set_content_i5lrjv_k$(tmp_0);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
        var this_0 = sizeConstraints(get_centered(element), VOID, VOID, VOID, VOID, VOID, get_rem(30));
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_1 = themed(this_0, ForcePaddingSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_1.willAddChild_hz2iwc_k$(element_1);
        element_1.set_align_ypalx0_k$(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value_0 = updateRequired ? strings.checkVersionRequiredBody_la1fe1_k$(latestRelease.version_1) : strings.checkVersionOptionalBody_2r7vzs_k$(latestRelease.version_1);
        var tmp_1 = element_1.native_1;
        var tmp_2;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value_0) === 0) {
          tmp_2 = '\xA0';
        } else {
          tmp_2 = value_0;
        }
        tmp_1.set_content_i5lrjv_k$(tmp_2);
        element_1.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        element.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(false);
        if (!updateRequired) {
          // Inline function 'com.lightningkite.kiteui.views.card' call
          // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
          var this_2 = themed(element_2, CardSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_3 = themed(this_2, ButtonSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_3 = new (Button())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_3);
          this_3.willAddChild_hz2iwc_k$(element_3);
          text(get_centered(element_3), strings.get_checkVersionOkButton_hri5kp_k$());
          onClick(element_3, VOID, VOID, VOID, checkAppVersion$slambda$lambda$slambda(close));
          element_3.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_3);
        }
        element_2.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_2);
        element.onStartup_vrxh3i_k$();
        $this$dialog.addChild_2qpft2_k$(element);
        return Unit_instance;
      });
      tmp_5 = Unit_instance;
    }
    return Unit_instance;
  }), 1);
}
//region block: init
appUpdateChecked = false;
//endregion
//region block: exports
export {
  checkAppVersion as checkAppVersion2crh954ac2m1p,
};
//endregion

//# sourceMappingURL=checkAppVersion.mjs.map
